interface MicrositeTimeModalProps {
  timings: {
    day: string;
    open: boolean;
    openingTime: string;
    closingTime: string;
  }[];
  themeColor: string;
}

const MicrositeTimeModal: React.FC<MicrositeTimeModalProps> = ({ timings, themeColor="#885ABB" }) => {
  return (
    <div className="w-full sm:w-[90%] md:w-[100%] bg-white rounded-2xl p-6 shadow-lg border border-gray-100 max-w-3xl mx-auto transition-all duration-300 font-serif">
      <h2
        className="text-2xl sm:text-3xl font-bold text-center mb-2 tracking-wide"
        style={{ color: themeColor }}
      >
        Business Hours
      </h2>
      <p className="text-gray-500 text-center mb-8 text-sm sm:text-base">
        Here’s when we’re open for appointments.
      </p>

      {/* Timings Table */}
      <div className="flex flex-col gap-3">
        {timings.map((day, index) => (
          <div
            key={index}
            className={`flex flex-col sm:flex-row sm:items-center justify-between p-4 sm:p-5 rounded-xl ${
              index % 2 === 0 ? "bg-gray-50/50" : "bg-white"
            }`}
          >
            <div className="flex items-center justify-between sm:justify-start w-full sm:w-auto gap-3 mb-2 sm:mb-0">
              <span className="font-medium text-gray-800 text-base sm:text-lg">{day.day}</span>
              <span
                className={`text-sm sm:text-base font-semibold transition-colors duration-200 ${
                  day.open ? "text-green-600" : "text-red-500"
                }`}
              >
                {day.open ? "Open" : "Closed"}
              </span>
            </div>

            {day.open && (
              <div className="flex items-center gap-3 justify-between sm:justify-end w-full sm:w-auto">
                <div
                  className="px-3 py-1.5 text-sm sm:text-base rounded-lg border font-medium text-gray-700"
                  style={{ borderColor: themeColor }}
                >
                  {day.openingTime}
                </div>
                <span className="text-gray-500 text-sm sm:text-base">to</span>
                <div
                  className="px-3 py-1.5 text-sm sm:text-base rounded-lg border font-medium text-gray-700"
                  style={{ borderColor: themeColor }}
                >
                  {day.closingTime}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="text-xs sm:text-sm text-gray-400 text-center mt-6 italic">
        *Timings may vary on public holidays.
      </div>
    </div>
  );
};
export default MicrositeTimeModal;
